import { STORAGE_KEYS } from "../lib/constants"

export const setUserId = (id: string) => {
  localStorage.setItem(STORAGE_KEYS.USER_ID, id)
}
